module.exports = __webpack_public_path__ + "img/dark_ic_new_anim.9a61feb4.png";